var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CustomGlobalStyle, ExpandIconWrapper, MenuTitle } from './styled';
import { Menu } from '../../Layout/components';
import { Link } from 'react-router-dom';
import { useQuery } from '../../../hooks';
var LayoutMenu = function (_a) {
    var menu = _a.menu, collapsed = _a.collapsed, renderMenuItem = _a.renderMenuItem, props = __rest(_a, ["menu", "collapsed", "renderMenuItem"]);
    var pathname = useQuery().pathname;
    var renderItem = function (item) {
        var title = item.title, link = item.link, linkTarget = item.linkTarget, subMenu = item.subMenu, external = item.external, _a = item.level, level = _a === void 0 ? 1 : _a, rest = __rest(item, ["title", "link", "linkTarget", "subMenu", "external", "level"]);
        if (subMenu === null || subMenu === void 0 ? void 0 : subMenu.length) {
            return (React.createElement(Menu.SubMenu, __assign({}, rest, { title: title, popupClassName: "custom-submenu custom-submenu-level-" + level, popupOffset: [16, 0] }), subMenu === null || subMenu === void 0 ? void 0 : subMenu.map(function (subMenuItem) { return renderItem(__assign(__assign({}, subMenuItem), { level: level + 1 })); })));
        }
        return (React.createElement(Menu.Item, __assign({}, rest),
            renderMenuItem && renderMenuItem(item),
            !renderMenuItem && (React.createElement(React.Fragment, null, !link ? (title) : external ? (React.createElement("a", __assign({ href: link }, (linkTarget && { target: linkTarget }), (linkTarget === '_blank' && { rel: 'noopener noreferrer' })), title)) : (React.createElement(Link, { to: link, target: linkTarget }, title))))));
    };
    if (!(menu === null || menu === void 0 ? void 0 : menu.length))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(CustomGlobalStyle, null),
        React.createElement(Menu, __assign({ inlineCollapsed: collapsed ? collapsed : undefined, mode: 'inline', inlineIndent: 12, expandIcon: function (_a) {
                var isOpen = _a.isOpen;
                return (React.createElement(ExpandIconWrapper, { className: 'ant-menu-submenu-expand-icon', "$isOpen": isOpen }));
            }, selectedKeys: [pathname], defaultSelectedKeys: [pathname] }, props), menu === null || menu === void 0 ? void 0 : menu.map(function (_a) {
            var key = _a.key, title = _a.title, items = _a.items;
            return (React.createElement(React.Fragment, { key: key },
                !collapsed && title && React.createElement(MenuTitle, null, title),
                items.map(renderItem)));
        }))));
};
export default LayoutMenu;
//# sourceMappingURL=LayoutMenu.js.map